import currencies from '@/assets/currencies';

/** Shown first in currency pickers; any other ISO codes follow in alphabetical order. */
const CURRENCY_PINNED_ORDER = ['GBP', 'EUR', 'USD', 'UAH'];

export default {
  
  DEFAULT_CURRENCY_CODE: CURRENCY_PINNED_ORDER[0],
  getProperTime(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes()
      )
    );
  },
  getAuthorizeAxiosConfig(accessToken) {
    return {
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
    };
  },
  filterEmptyFields(component, fields) {
    let result = {};
    fields.forEach((field) => {
      if (component[field]) {
        result[field] = component[field];
      }
    });
    return Object.keys(result).length === 0 ? null : result;
  },
  getCurrencySymbol(currency) {
    return currencies[0][currency].symbol || '';
  },
  /**
   * @param {string[]} codes
   * @returns {string[]}
   */
  sortCurrencyCodeList(codes) {
    if (!Array.isArray(codes) || !codes.length) return codes;
    const unique = [...new Set(codes)];
    const pinnedSet = new Set(CURRENCY_PINNED_ORDER);
    const pinned = CURRENCY_PINNED_ORDER.filter((c) => unique.includes(c));
    const rest = unique
      .filter((c) => !pinnedSet.has(c))
      .sort((a, b) => a.localeCompare(b, 'en'));
    return [...pinned, ...rest];
  },
};
